var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("form", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-12 form-group form-group__animated",
            class: { "form-group--error": !_vm.errors.name },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.name,
                  expression: "value.name",
                },
              ],
              staticClass:
                "form-group__input form-group__input--paddings-classic form-group__animated__input",
              attrs: {
                type: "text",
                name: _vm.name + "-given-name",
                id: _vm.name + "-client_name",
                placeholder: _vm.$t("name", "form_company_data"),
              },
              domProps: { value: _vm.value.name },
              on: {
                blur: _vm.validate_name,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.value, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-group__animated__label",
                attrs: { for: _vm.name + "-client_name" },
              },
              [_vm._v(_vm._s(_vm.$t("name", "form_company_data")))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 form-group form-group__animated",
            class: { "form-group--error": !_vm.errors.secondName },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.secondName,
                  expression: "value.secondName",
                },
              ],
              staticClass:
                "form-group__input form-group__input--paddings-classic form-group__animated__input",
              attrs: {
                type: "text",
                name: _vm.name + "-family-name",
                id: _vm.name + "-client_second_name",
                placeholder: _vm.$t("last_name", "form_company_data"),
              },
              domProps: { value: _vm.value.secondName },
              on: {
                blur: _vm.validate_secondName,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.value, "secondName", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-group__animated__label",
                attrs: { for: _vm.name + "-client_second_name" },
              },
              [_vm._v(_vm._s(_vm.$t("last_name", "form_company_data")))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 form-group form-group__animated",
            class: { "form-group--error": !_vm.errors.addressEmail },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.addressEmail,
                  expression: "value.addressEmail",
                },
              ],
              staticClass:
                "form-group__input form-group__input--paddings-classic form-group__animated__input",
              attrs: {
                type: "email",
                name: "email",
                id: _vm.name + "-client_address_email",
                placeholder: "Adres email",
              },
              domProps: { value: _vm.value.addressEmail },
              on: {
                blur: _vm.validate_addressEmail,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.value, "addressEmail", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-group__animated__label",
                attrs: { for: _vm.name + "-client_address_email" },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("email", "form_company_data")) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 form-group form-group__animated",
            class: { "form-group--error": !_vm.errors.message },
          },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.message,
                  expression: "value.message",
                },
              ],
              staticClass:
                "form-group__input form-group__input--paddings-classic form-group__animated__input",
              attrs: {
                type: "text",
                rows: "5",
                name: "message",
                id: _vm.name + "-client_message",
                placeholder: "Wiadomość",
              },
              domProps: { value: _vm.value.message },
              on: {
                blur: _vm.validate_message,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.value, "message", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "form-group__animated__label form-group__animated__label--to-top",
                attrs: { for: _vm.name + "-client_message" },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message", "form_company_data")) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 pt-4 text-center" }, [
          _c(
            "a",
            {
              staticClass:
                "button button__size-2 button__font--size-2 text-white button__new button__new--blue",
              class: { "button__bg--blue btn-loader": _vm.btnLoader },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.sendMessage.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("send", "checkout")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("contact-data-response", {
        attrs: {
          popup_visibility: _vm.showPopup,
          popup_title: _vm.sendResponse.title,
          popup_message: _vm.sendResponse.message,
        },
        on: {
          "update:popup_visibility": function ($event) {
            _vm.showPopup = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }